import type {FC} from 'react';
import {pluralizeWord} from '~/common/utils';
import {Typography} from '~library/atoms/Typography';

interface ResultsCountProps {
  numTemplates: number;
  inline?: boolean;
}

export const ResultsCount: FC<ResultsCountProps> = ({numTemplates, inline = false}) => {
  if (inline) return <span data-qa-id="gallery__results-count">({numTemplates})</span>;

  return (
    <Typography variant="paragraph2" color="pebble" data-qa-id="gallery__results-count">
      {numTemplates} {pluralizeWord('result', numTemplates)}
    </Typography>
  );
};
